import { render } from "./SbmDashboard.vue?vue&type=template&id=34ddbb10&scoped=true"
import script from "./SbmDashboard.vue?vue&type=script&lang=js"
export * from "./SbmDashboard.vue?vue&type=script&lang=js"

import "./SbmDashboard.vue?vue&type=style&index=0&id=34ddbb10&lang=css"
import "./SbmDashboard.vue?vue&type=style&index=1&id=34ddbb10&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ddbb10"]])

export default __exports__